<template>
    <button
        class="alertTrigger"
        :class="{'-isOpen' : isOpen, '-warningActive' : warning }"
        :disabled="!alerts.length"
        :tabindex="alerts.length ? 0 : -1"
        :aria-label="alertText"
        @click="onClickTrigger"
        @focus.capture="triggerFocus(true)"
        @blur.capture="triggerFocus(false)"
    >
        <svg class="alertTrigger__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
            <g id="alert-trigger">
                <circle class="alertTrigger__iconBg" cx="11.5" cy="11.5" r="11.5" fill="#fff"/>
                <g
                    v-if="!isOpen"
                    class="alertTrigger__iconBell"
                >
                    <path d="M15.4,8.9c0-2.15-1.75-3.9-3.9-3.9-2.15,0-3.9,1.75-3.9,3.9h0c0,4.55-1.95,5.85-1.95,5.85h11.7s-1.95-1.3-1.95-5.85" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.62,17.35c-.36,.62-1.16,.83-1.78,.47-.2-.11-.36-.28-.47-.47" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>
                    <g
                        v-if="alerts.length && !isOpen"
                        class="alertTrigger__iconActive"
                    >
                        <circle cx="14.78" cy="6.57" r="3.5" fill="#ffc64d"/>
                        <circle cx="14.78" cy="6.57" r="3" fill="none" stroke="#012f7e"/>
                    </g>
                </g>
                <g
                    v-if="isOpen"
                    class="alertTrigger__iconClose"
                >
                    <line x1="7.5" y1="7.5" x2="15.5" y2="15.5" fill="none" stroke="#000" stroke-linecap="round"/>
                    <line x1="15.5" y1="7.5" x2="7.5" y2="15.5" fill="none" stroke="#000" stroke-linecap="round"/>
                </g>
            </g>
        </svg>
    </button>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {

    computed: {
        ...mapState({
            alerts: 'alerts',
            initialComplete: 'initialModeComplete',
            isOpen: 'alertPanelOpen',
            warning: 'warningActive',
        }),

        alertText () {
            return !this.alerts.length
                ? 'No Alerts for this page'
                : this.alerts.length === 1
                    ? '1 Alert'
                    : `${this.alerts.length} Alerts`
        }
    },

    methods: {
        ...mapMutations({
            toggleAlerts: 'TOGGLE_ALERT_PANEL',
            openAlerts: 'SET_ALERT_PANEL_OPEN',
            closeAlerts: 'SET_ALERT_PANEL_CLOSED',
            updateInitial: 'UPDATE_INITIAL',
            triggerFocus: 'SET_TRIGGER_FOCUS',
            removeWarning: 'REMOVE_WARNING',
        }),

        onClickTrigger () {
            if (this.isOpen && !this.initialComplete) {
                this.removeWarning()
                this.updateInitial({ hasClickedTrigger: true })
            }

            if (!this.isOpen && this.warning) {
                this.removeWarning()
            }

            if (!localStorage.getItem('alertsClosedTimestamp')) {
                localStorage.setItem('alertsClosedTimestamp', new Date().getTime())
            }

            this.toggleAlerts()
        },
    },
}
</script>
